import React from 'react';
import Progress from '../Shared/Progress.js';

class Skills extends React.Component {
  render() {
    const skills = [
      {
        title: 'Core',
        category: 'Frontend',
        summary: ['JavaScript', 'Database', 'HTML5', 'CSS3']
      }, {
        title: 'JS Frameworks / Libraries',
        category: 'Frontend',
        summary: ['NodeJS', 'NextJS', 'VueJS', 'React', 'Lodash', 'ExpressJS', 'MomentJS', 'Angular', 'jQuery', 'Knockout', 'Underscore']
      }, {
        title: 'CSS Frameworks',
        category: 'Frontend',
        summary: ['Bootstrap', 'Foundation']
      }, {
        title: 'Databases',
        category: 'Frontend',
        summary: ['MongoDB', 'ElasticSearch', 'Redis', 'MySQL']
      }, {
        title: 'Package Managers',
        category: 'Frontend',
        summary: ['npm', 'Bower']
      }, {
        title: 'Templating',
        category: 'Frontend',
        summary: ['EJS', 'Mustache', 'Pug', 'Swig']
      }, {
        title: 'CSS Preprocessors',
        category: 'Frontend',
        summary: ['Stylus', 'Sass', 'Less', 'PostCSS']
      }, {
        title: 'Process Automation',
        category: 'Frontend',
        summary: ['Grunt', 'Gulp']
      }, {
        title: 'Code Quality',
        category: 'Frontend',
        summary: ['JSLint', 'ESLint']
      }, {
        title: 'Style Guides',
        category: 'Frontend',
        summary: ['Suit CSS', 'MVCSS', 'OOCSS', 'BEM', 'SMACSS', 'Inuitcss', 'KSS']
      }, {
        title: 'Version Control',
        category: 'Frontend',
        summary: ['GitHub', 'GitLab', 'Subversion']
      }, {
        title: 'Performance',
        category: 'Frontend',
        summary: ['Lighthouse', 'DevTool', 'PictureFill', 'Critical CSS']
      }, {
        title: 'Build Tools',
        category: 'Frontend',
        summary: ['Require', 'WebPack', 'Browserify']
      }, {
        title: 'Testing',
        category: 'Frontend',
        summary: ['Jest', 'Karma', 'Jasmine']
      }, {
        title: 'Editors',
        category: 'Frontend',
        summary: ['WebStorm', 'VS Code', 'Atom', 'Brackets']
      }
    ];

    return (
      <div className="app">
        <h1 className="app-heading">Skills</h1>

        <Progress data={skills} />
      </div>
    );
  }
}

export default Skills;



// WEBPACK FOOTER //
// ./src/Pages/Skills.js